import { Box, useTheme } from '@mui/material'

interface IProps {
  count: number | undefined
}

export const FoundItemsCounter = ({ count }: IProps) => {
  const theme = useTheme()

  if (!count) return null

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: theme.palette.custom.black,
          borderRadius: '16px',
          padding: '8px 16px',
        }}
      >
        {`${count} item${count > 1 ? 's' : ''} found`}
      </Box>
    </Box>
  )
}
